import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import style from '../address-validation.module.less';

export const messages = defineMessages({
  emptyAddress: {
    description: 'Error validation message if the address is missing values needed to create a label',
    defaultMessage: 'Ship To Address is required to ship',
    id: '51zQep',
  },
});

const ValidationErrorEmptyAddress = ({ className = '', validationMessageClassName }) => {
  return (
    <div className={classnames(className, style['validation-issue'], style.error)}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <Tooltip>
        <div className={classnames(style.message, validationMessageClassName)}>
          <FormattedMessage {...messages.emptyAddress} />
        </div>
        <TooltipContent>
          <FormattedMessage {...messages.emptyAddress} />
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

ValidationErrorEmptyAddress.propTypes = {
  className: PropTypes.string,
  validationMessageClassName: PropTypes.string,
};

export { ValidationErrorEmptyAddress };
